import { translatedEffectNames } from 'shared/core/utils/library-products/effects';

/**
 * Review effect options, in display order. The server schema (ECOMM-10627)
 * types `effects` as `[String!]` rather than an enum, so this list is the
 * client-side source of truth: it drives the chip ordering, the `ReviewEffect`
 * type, and the per-effect icon/label maps (see `EFFECT_ICONS` and
 * `getEffectLabel`). Keep it aligned with the values the backend accepts.
 */
export const REVIEW_EFFECTS = [
  'calm',
  'clearMind',
  'creative',
  'energetic',
  'focused',
  'happy',
  'inspired',
  'relaxed',
  'sleepy',
  'uplifted',
] as const;

export type ReviewEffect = typeof REVIEW_EFFECTS[number];
export const getEffectLabel = (effect: ReviewEffect): string => translatedEffectNames[effect] ?? effect;
